module.exports = __webpack_public_path__ + "media/assets/faria_products/PRIMARY-e6f0f15f1b3b98ac1176b5e48510cacf365583509761c8f5c5b75170d964bbd4.png";